import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-themify-icons',
	templateUrl:'./ThemifyIconsPluginPage.html',
	styles: [],
	styleUrls:['./ThemifyIconsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ThemifyIconsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_653 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>themify-icons</artifactId>
</dependency>
\`\`\``;
	mdContent_654 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:themify-icons")
\`\`\``;
	mdContent_655 = `\`\`\`java
var home = new ThemifyIcon<>(ThemifyIcons.home);
var search = new ThemifyIcon<>(ThemifyIcons.search);
var github = new ThemifyIcon<>(ThemifyIcons.github);
\`\`\``;
	mdContent_656 = `\`\`\`java
// Create a Themify icon
var icon = new ThemifyIcon<>(ThemifyIcons.home);

// Arrow icons
var arrow = new ThemifyIcon<>(ThemifyIcons.arrow_right);

// Social icons
var github = new ThemifyIcon<>(ThemifyIcons.github);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
